import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import dayjs from "dayjs";

import "./expenseManagementStyle.css";
import CustomAutoCompleteDropdown from "../../../../components/custom_auto_complete_dropdown/CustomAutoCompleteDropdown";
import CustomDatePicker from "../../../../components/custom_date_picker/CustomDatePicker";
import { get_status } from "../../../../api/statusApis";

function ExpenseManagementFilter({ searchFilter }) {
  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    fetchStatusList();
  }, []);

  const fetchStatusList = async () => {
    try {
      const response = await get_status();
      const options = response.map((item) => ({
        label: item.status_name,
        value: item.id,
      }));
      setStatusOptions(options);
    } catch (error) {
      console.error("Error fetching status list:", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      status_id: "",
      start_date: null,
      end_date: null,
    },
    onSubmit: (values) => {
      searchFilter(values);
    },
  });

  const resetFilter = () => {
    formik.resetForm();
    searchFilter(null);
  };

  return (
    <div className="expense-filter">
      <form
        id="expense-filter-form"
        className="expense-filter__form"
        onSubmit={formik.handleSubmit}
      >
        <div className="expense-filter__controls">
          {/* Status Filter */}
          <div className="expense-filter__field">
            <CustomAutoCompleteDropdown
              name="status_id"
              placeholder="Select an expense head"
              options={statusOptions}
              onChange={(event, newValue) =>
                formik.setFieldValue("status_id", newValue ? newValue.value : "")
              }
              onBlur={formik.handleBlur}
              value={
                statusOptions.find(
                  (status) => status.value === formik.values.status_id
                ) || null
              }
            />
          </div>

          {/* Date Filter */}
          <div className="expense-filter__date-range">
            <div className="expense-filter__date-field">
              <p className="expense-filter__label">Issue Start Date</p>
              <CustomDatePicker
                no_border
                name="start_date"
                onChange={(date) => formik.setFieldValue("start_date", date)}
                onBlur={formik.handleBlur}
                value={formik.values.start_date ? dayjs(formik.values.start_date, "DD-MM-YYYY") : null}
                error={formik.touched.start_date && Boolean(formik.errors.start_date)}
                helperText={formik.touched.start_date && formik.errors.start_date}
              />
            </div>

            <div className="expense-filter__date-separator">-</div>

            <div className="expense-filter__date-field">
              <p className="expense-filter__label">End Date</p>
              <CustomDatePicker
                no_border
                disabled={!formik.values.start_date}
                minDate={formik.values.start_date ? dayjs(formik.values.start_date, "DD-MM-YYYY") : null}
                name="end_date"
                onChange={(date) => formik.setFieldValue("end_date", date)}
                onBlur={formik.handleBlur}
                value={formik.values.end_date ? dayjs(formik.values.end_date, "DD-MM-YYYY") : null}
                error={formik.touched.end_date && Boolean(formik.errors.end_date)}
                helperText={formik.touched.end_date && formik.errors.end_date}
              />
            </div>
          </div>

          {/* Actions */}
          <div className="expense-filter__actions">
            <button
              type="button"
              className="expense-filter__action_reset"
              onClick={resetFilter}
            >
              Reset
            </button>
            <button
              type="submit"
              className="expense-filter__action_search"
              form="expense-filter-form"
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ExpenseManagementFilter;
